<div class="row pt-0">
    <div class="col-12">
        <ngx-loading [show]="loadingIndicator"></ngx-loading>
     
        <h5>Fuel Levy Management</h5>
        <p class="text-muted subheader">Allows management fuel levy records.</p>

        <!-- START FUNCTION BUTTONS --><br/>
        <div class="row mb-1 pt-0">
            <div class="col-md-12" align="left">
                <button type="button" class="btn btn-sm btn-secondary tt mb-1 mr-1" (click)="openFuelLevyModal(null)">
                    <i class="fa fa-lg fa-plus"></i>
                    <span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Add Fuel Levy</span>
                </button>
                
                <div class="btn-group mb-1 mr-1">
                    <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span class="sr-only">Toggle Dropdown</span>
                        <i class="fa fa-lg fa-check-square-o"></i>
                        <span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Columns</span>
                    </button>

                    <div class="dropdown-menu fs-12" style="width: 170px;">
                        <div class="col-md-12 mb-3 fs-12">
                            <input type="checkbox" name="showMonth" [(ngModel)]="showMonth"> Month<br />
                            <input type="checkbox" name="showYear" [(ngModel)]="showYear"> Year<br />
                            <input type="checkbox" name="showLocal" [(ngModel)]="showLocal"> Local Fuel Levy<br />
                            <input type="checkbox" name="showLinehaul" [(ngModel)]="showLinehaul"> Linehaul Fuel Levy<br />
                            <input type="checkbox" name="showCreatedDate" [(ngModel)]="showCreatedDate"> Created Date<br />
                            <input type="checkbox" name="showCreatedName" [(ngModel)]="showCreatedName"> Created By<br />
                            <input type="checkbox" name="showUpdatedDate" [(ngModel)]="showUpdatedDate"> Updated Date<br />
                            <input type="checkbox" name="showUpdatedName" [(ngModel)]="showUpdatedName"> Updated By<br />
                        </div>
                    </div>
                </div>

                <button type="button" [ngClass]="(showFilters)?'btn-success':'btn-secondary'" class="btn btn-sm btn-secondary tt mb-1 mr-1" (click)="toggleFilters()" placement="bottom" ngbTooltip="Filter List">
                    <i class="fa fa-lg fa-filter"></i>
                    <span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Filter</span>
                </button>

                <button type="button" class="btn btn-sm btn-secondary tt mb-1 mr-1" placement="bottom" [disabled]="count < 1" ngbTooltip="Print List" (click)="printer.print('fuellevy-print-section', 'Fuel Levy')">
                    <i class="fa fa-lg fa-print"></i>
                    <span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Print</span>
                </button>

                <div class="btn-group mr-1">
                    <button type="button" class="btn btn-sm btn-secondary dropdown-toggle mb-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" [disabled]="count < 1"
                    placement="bottom" ngbTooltip="Export List">
                        <i class="fa fa-lg fa-download"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Export</span>
                    </button>
                    <div class="dropdown-menu fs-12">
                        <a (click)="fuellevy_exportToCSV()" class="dropdown-item" href="javascript:void(0);">Export to CSV</a> 
                        <a (click)="fuellevy_exportToExcel()" class="dropdown-item" href="javascript:void(0);">Export to Excel</a> 
                        <a (click)="fuellevy_exportToPDF()" class="dropdown-item" href="javascript:void(0);">Export to PDF</a> 
                    </div>
                </div>
            </div>
        </div><!-- END FUNCTION BUTTONS-->
        <!-- <br *ngIf="showSummary"/> -->

        <!-- LIST TABLE -->
        <div class="row pt-3 pl-0">
            <div  class="col-md-12">
                <a (click)="resetFilter()" container="body" placement="top">Reset Filter&nbsp;<i class="fa fa-rotate-left"></i></a>
                <ngx-datatable *ngIf="!loadingIndicator"
                    [loadingIndicator]="loadingIndicator"
                    class="material"
                    [columns]="columns"
                    [rows]="rows"
                    [columnMode]="'force'"
                    [headerHeight]="30"
                    [footerHeight]="40"
                    [rowHeight]="'auto'"
                    [limit]="20"
                    [selectionType]="'single'"
                    [scrollbarH]="true"
                    [headerHeight]="showFilters?50:30">

                    <ngx-datatable-column prop="id" name="Operations" headerClass="header" [width]="120" > 
                        <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                            <div class="text-left" style="display:inline;padding:0px">
                                <a container="body" placement="top" ngbTooltip="Update" (click)="openFuelLevyModal(row)"><i class="fa fa-lg fa-pencil"></i>&nbsp;</a>
                                <a container="body" placement="top" ngbTooltip="Delete" (click)="openDeleteFuelLevyModal(row)"><i class="fa fa-lg fa-trash"></i>&nbsp;</a>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column *ngIf="showMonth" prop="month_name" name="Month" headerClass="header" [width]="180" [sortable]="true">
                        <ng-template let-column="column" let-sort="sortfn" ngx-datatable-header-template>
                            <span (click)="sort()">{{column.name}}</span>
                            <span *ngIf="showFilters">
                                <input type="text" [(ngModel)]="filterMonth" style="height:17px" 
                                    class="pt-1 pb-0 mt-0 mb-0 noborder input-sm form-control form-control-sm"
                                    (keyup)="updateFilter(null)" />
                            </span>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column *ngIf="showYear" prop="year" name="Year" headerClass="header" [width]="180" [sortable]="true">
                        <ng-template let-column="column" let-sort="sortfn" ngx-datatable-header-template>
                            <span (click)="sort()">{{column.name}}</span>
                            <span *ngIf="showFilters">
                                <input type="text" [(ngModel)]="filterYear" style="height:17px" 
                                    class="pt-1 pb-0 mt-0 mb-0 noborder input-sm form-control form-control-sm"
                                    (keyup)="updateFilter(null)" />
                            </span>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column *ngIf="showLocal" prop="local" name="Local Fuel Levy" headerClass="header" [width]="180" [sortable]="true">
                        <ng-template let-column="column" let-sort="sortfn" ngx-datatable-header-template>
                            <span (click)="sort()">{{column.name}}</span>
                            <span *ngIf="showFilters">
                                <input type="text" [(ngModel)]="filterLocal" style="height:17px" 
                                    class="pt-1 pb-0 mt-0 mb-0 noborder input-sm form-control form-control-sm"
                                    (keyup)="updateFilter(null)" />
                            </span>
                        </ng-template>
                        <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                            {{value | number:'1.2-2'}}%
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column *ngIf="showLinehaul" prop="linehaul" name="Linehaul Fuel Levy" headerClass="header" [width]="180" [sortable]="true">
                        <ng-template let-column="column" let-sort="sortfn" ngx-datatable-header-template>
                            <span (click)="sort()">{{column.name}}</span>
                            <span *ngIf="showFilters">
                                <input type="text" [(ngModel)]="filterLinehaul" style="height:17px" 
                                    class="pt-1 pb-0 mt-0 mb-0 noborder input-sm form-control form-control-sm"
                                    (keyup)="updateFilter(null)" />
                            </span>
                        </ng-template>
                        <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                            {{value | number:'1.2-2'}}%
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column *ngIf="showCreatedDate" prop="created_at" name="Created Date" headerClass="header" [width]="180" [sortable]="true">
                        <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                            <div align="left" placement="top" container="body" style="padding-right:5px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; width: 100%; ">
                                {{ ((value) !== null ) ? ((value) | date: 'dd MMM yyyy') : "No Date"  }}
                            </div>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column *ngIf="showCreatedName" prop="created_name" name="Created By" headerClass="header" [width]="180" [sortable]="true">
                        <ng-template let-column="column" let-sort="sortfn" ngx-datatable-header-template>
                            <span (click)="sort()">{{column.name}}</span>
                            <span *ngIf="showFilters">
                                <input type="text" [(ngModel)]="filterCreatedName" style="height:17px" 
                                    class="pt-1 pb-0 mt-0 mb-0 noborder input-sm form-control form-control-sm"
                                    (keyup)="updateFilter(null)" />
                            </span>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column *ngIf="showUpdatedDate" prop="updated_at" name="Updated Date" headerClass="header" [width]="180" [sortable]="true">
                        <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                            <div align="left" placement="top" container="body" style="padding-right:5px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; width: 100%; ">
                                {{ ((value) !== null) ? ((value) | date: 'dd MMM yyyy') : "No Date"  }}
                            </div>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column *ngIf="showUpdatedName" prop="updated_name" name="Updated By" headerClass="header" [width]="180" [sortable]="true">
                        <ng-template let-column="column" let-sort="sortfn" ngx-datatable-header-template>
                            <span (click)="sort()">{{column.name}}</span>
                            <span *ngIf="showFilters">
                                <input type="text" [(ngModel)]="filterUpdatedName" style="height:17px" 
                                    class="pt-1 pb-0 mt-0 mb-0 noborder input-sm form-control form-control-sm"
                                    (keyup)="updateFilter(null)" />
                            </span>
                        </ng-template>
                    </ngx-datatable-column>

                </ngx-datatable>
            </div>
        </div>
    </div>
</div>


<!-- START PRINT-->
<div id="fuellevy-print-section" style="display:none">
    <table style="width:100%">
              
        <thead>
            <tr> 
                <th class="text-left" *ngIf="showMonth"><small><strong>Month</strong></small></th> 
                <th class="text-left" *ngIf="showYear"><small><strong>Year</strong></small></th> 
                <th class="text-left" *ngIf="showLocal"><small><strong>Local Fuel Levy</strong></small></th> 
                <th class="text-left" *ngIf="showLinehaul"><small><strong>Linehaul Fuel Levy</strong></small></th> 
                <th class="text-left" *ngIf="showCreatedDate"><small><strong>Created Date</strong></small></th> 
                <th class="text-left" *ngIf="showCreatedName"><small><strong>Created By</strong></small></th> 
                <th class="text-left" *ngIf="showUpdatedDate"><small><strong>Updated Date</strong></small></th> 
                <th class="text-left" *ngIf="showUpdatedName"><small><strong>Updated By</strong></small></th> 
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let fuel_levy of rows">   
                <td class="text-muted" *ngIf="showMonth"><small>{{showMonthName(fuel_levy.month)}}</small></td>
                <td class="text-muted" *ngIf="showYear"><small>{{fuel_levy.year}}</small></td>
                <td class="text-muted" *ngIf="showLocal"><small>{{fuel_levy.local | number: '1.2-2'}}%</small></td>
                <td class="text-muted" *ngIf="showLinehaul"><small>{{fuel_levy.linehaul | number: '1.2-2'}}%</small></td>
                <td class="text-muted" *ngIf="showCreatedDate"><small>{{ ((fuel_levy.created_at) != null && fuel_levy.created_at != '0000-00-00') ? ((fuel_levy.created_at) | date: 'dd MMM yyyy') : "No Date"  }}</small></td>
                <td class="text-muted" *ngIf="showCreatedName"><small>{{fuel_levy.created_name}}</small></td>
                <td class="text-muted" *ngIf="showUpdatedDate"><small> {{ ((fuel_levy.updated_at) != null && fuel_levy.updated_at != '0000-00-00') ? ((fuel_levy.updated_at) | date: 'dd MMM yyyy') : "No Date"  }}</small></td>
                <td class="text-muted" *ngIf="showUpdatedName"><small>{{fuel_levy.updated_name}}</small></td>                     
            </tr>
        </tbody>
    
    </table>
</div>



<!-- START OF DELETE FUEL LEVY MODAL -->
<ng-template #modalDeleteFuelLevy let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">Delete Fuel Levy</h5>
        <button type="button" class="close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12">
              Do you really want to delete <strong>{{showMonthName(fuel_levy.month)}} {{fuel_levy.year}}</strong> fuel levy record?<br>
                <i>Local Fuel Levy:<b> {{fuel_levy.local | number: '1.2-2'}}% </b>, Linehaul Fuel Levy: <b>{{fuel_levy.linehaul  | number: '1.2-2'}}% </b></i>
            </div>     
        </div>   
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-danger"  (click)="deleteFuelLevy(fuel_levy)">Delete</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="closeModal()">Cancel</button>
    </div>
</ng-template>
<!-- END OF MODAL FUEL LEVY -->


<!-- START OF FUEL LEVY FORM -->
<ng-template #modalFuelLevy let-close="close">

    <div class="modal-header">
        <h5 class="modal-title" *ngIf="isEditMode==false">Add New Fuel Levy</h5>
        <h5 class="modal-title" *ngIf="isEditMode==true">Update Fuel Levy</h5>

        <button type="button" class="close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="frm_fuel_levy" (ngSubmit)="onSubmitFuelLevy(frm_fuel_levy.value)">

        <div class="modal-body bg-gray">
            <div class="row" *ngIf="is_past">&nbsp;&nbsp;<h6 class="text-danger"><i class="fa fa-warning"></i><i>This is already a past record, updating this may result to breach.</i></h6></div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <h6 for="input-1">Month<span class="text-danger">*</span> :</h6>
                        <select id="month" class="form-control form-control-sm" formControlName="month" required (change)="checkRecords(frm_fuel_levy.value)"> 
                            <option value="1">Jan</option>
                            <option value="2">Feb</option>
                            <option value="3">Mar</option>
                            <option value="4">Apr</option>
                            <option value="5">May</option>
                            <option value="6">Jun</option>
                            <option value="7">Jul</option>
                            <option value="8">Aug</option>
                            <option value="9">Sept</option>
                            <option value="10">Oct</option>
                            <option value="11">Nov</option>
                            <option value="12">Dec</option>
                        </select> 
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <h6 for="input-1">Year<span class="text-danger">*</span> :</h6>
                        <select id="year" class="form-control form-control-sm" formControlName="year" required (change)="checkRecords(frm_fuel_levy.value)"> 
                            <option *ngFor="let yr of years" value="{{yr}}">{{yr}}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <a *ngIf="is_unified" href="javascript:void(0);" class="transition" placement="bottom" ngbTooltip="Toggle Off."><i class="fa fa-lg fa-toggle-on text-success" (click)="toggleLocalLinehaul(false)"></i></a>
                        <a *ngIf="!is_unified" href="javascript:void(0);" class="transition" placement="bottom" ngbTooltip="Toggle On."><i class="fa fa-lg fa-toggle-off" (click)="toggleLocalLinehaul(true)"></i></a>
                        <span><h6 style="display:inline">Use same value for Local & Linehaul Fuel Levy</h6></span>
                        
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <h6 *ngIf="!is_unified" for="input-1">Local Fuel Levy<span class="text-danger">*</span> :</h6><h6 *ngIf="is_unified" for="input-1">Local and Linehaul Fuel Levy<span class="text-danger">*</span> :</h6>
                        <div class="input-group input-group-sm">
                            <input class="form-control form-control-sm" formControlName="local" type="number" step=".01" min="0.01" max="100" required (keyup)="updateLinehaul($event)">
                            <div class="input-group-append"><span class="input-group-text">%</span></div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6" *ngIf="!is_unified">
                    <div class="form-group">
                        <h6 for="input-1">Linehaul Fuel Levy<span class="text-danger">*</span> :</h6>
                        <div class="input-group input-group-sm">
                            <input class="form-control form-control-sm" formControlName="linehaul" type="number" step=".01" min="0.01" max="100" required>
                            <div class="input-group-append"><span class="input-group-text">%</span></div>
                        </div>
                    </div>
                </div>
            </div>
            <br/>
            <small *ngIf="has_record" class="text-danger">There is already a record for the selected month and year.</small>
        </div>
        <div class="modal-footer">
            <button *ngIf="isEditMode==false" type="submit" class="btn btn-sm btn-success" [disabled]="(frm_fuel_levy.invalid || checkRecords(frm_fuel_levy.value))">Save</button>
            <button *ngIf="isEditMode==true" type="submit" class="btn btn-sm btn-success" [disabled]="(frm_fuel_levy.invalid || has_record)" >Save Changes</button>
            <button type="button" class="btn btn-sm btn-secondary" (click)="closeModal()">Cancel</button>
        </div>
    </form>
</ng-template>
<!-- END OF MODAL FUEL LEVY FORM -->
